'use client';

import type { IGetDashboardResponseData } from '@repo/sdk';
import type { JSX } from 'react';
// import { ActivityChart } from './activity-chart';
import { CollectionMastery } from './collection-mastery';
import { LevelsChart } from './levels-chart';
// import { PracticeTimeChart } from './practice-time-chart';
import { StatsOverview } from './stats-overview';
import { StreakCard } from './streak-card';

export function DashboardContent({
  dashboard,
}: {
  dashboard: IGetDashboardResponseData;
}): JSX.Element {
  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-bold">My Progress</h1>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <StreakCard streak={dashboard.streak} />
        <StatsOverview overall={dashboard.overall} />
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        <LevelsChart levels={dashboard.levels} />
        {/* <ActivityChart dailyProgress={dashboard.dailyProgress} /> */}
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        {/* <PracticeTimeChart practiceHours={dashboard.practiceHours} /> */}
        <CollectionMastery collections={dashboard.collections} />
      </div>
    </div>
  );
}
